<template>
  <v-dialog v-model="show" scrollable width="50%" persistent>
    <v-card>
      <Toolbar
        :title="showEdit ? 'Kibocsátó módosítása': 'Kibocsátó létrehozása'"
        :btn-title="showEdit ?'Módosítás': 'Létrehozás'"
        @btnClicked="showEdit ? updateIssuer() : createIssuer()"
        @close="reset"
      />

      <v-card-text class="pt-3">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Kibocsátó neve"
                  v-model="issuer.name"
                  clearable
                  :error-messages="getErrorMessage('name')"
                ></v-text-field>
              </v-col>

                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            label="Szabályozók"
                            :items="regulators"
                            item-text="name"
                            item-value="id"
                            v-model="issuer.regulators"
                            clearable
                            multiple
                            chips
                            :error-messages="getErrorMessage('regulators')"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                    {{ data.item.name }}
                                </v-chip>
                            </template>

                        </v-autocomplete>
                    </v-col>
                </v-row>

                <v-col cols="12" v-if="showEdit">
                <v-switch label="Aktív" v-model="issuer.is_active"></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditIssuerModal",
  computed: {
    ...mapGetters("Modal", {showEdit: "showEditModal", showCreate:'showCreateModal'}),
    ...mapGetters("Issuer", ["issuer"]),
    ...mapGetters("Regulator", ["regulators"]),
    ...mapGetters(["getErrorMessage"]),
      show:{
        get(){
            return this.showEdit || this.showCreate
          },
          set(val){
              this.showEdit= val;
              this.showCreate = val;
          }
      }
  },
    mounted() {
      this.getAllRegulators();
    },
    methods: {
    ...mapActions("Issuer", ["createIssuer","updateIssuer", "reset"]),
    ...mapActions("Regulator", ["getAllRegulators"]),
    remove (item) {
        const index = this.issuer.regulators.indexOf(item.id)
        if (index >= 0) this.issuer.regulators.splice(index, 1)
    },
  },
    watch:{
        showEdit() {
            if (this.showEdit) {
                this.$set(this.issuer, 'regulators', this.issuer.regulators.map(i => i.id))
            }
        }
    },
};
</script>

<style></style>
